<template>
  <div>
    <div id="menuWrapper">
      <div id="menuContainer">
        <!-- 窄版 -->
        <!-- <h1 class="HideTitle1" style="line-height: 30px; vertical-align: middle; margin-top: 7px">
          <a :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/home`">
            <div style="display: flex; align-items: center">
              <div style="width: 60px; height: 60px; display: flex; align-items: center; justify-content: center">
                <img name="logo" :src="ExhLogo" />
              </div>
              <div style="margin-left: 15px">
                <div name="Exhibition">{{ ExhibitionName }}</div>
              </div>
            </div>
          </a>
        </h1> -->

        <h1
          class="HideTitle"
          style="vertical-align: middle; margin-top: 12px; font-size: 14px"
        >
          <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/en/home">
            <div style="display: flex; align-items: center">
              <img name="logo" :src="ExhLogo" />
              <div style="margin-left: 5px">
                <div name="Exhibition" v-html="ExhibitionName"></div>
              </div>
            </div>
          </a>
        </h1>

        <h1
          class="HideTitle1"
          style="line-height: 30px; vertical-align: middle; margin-top: 13px"
        >
          <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/en/home">
            <div style="display: flex; align-items: center">
              <div
                style="
                  width: 60px;
                  height: 60px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img name="logo" :src="ExhLogo" />
              </div>
              <div style="margin-left: 15px">
                <div name="Exhibition" v-html="ExhibitionName"></div>
              </div>
            </div>
          </a>
        </h1>

        <h4 class="openMenu">Menu</h4>
        <div id="cover">
          <ul id="menu">
            <li id="home">
              <a
                :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/home?no=${RegNo}`"
                >Home</a
              >
            </li>

            <li id="directory" class="NavDirectory">
              <a
                :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/directory?no=${RegNo}`"
              >
                <span name="directoryTitleEn"></span>
              </a>
            </li>

            <li id="profile">
              <a
                >Exhibitor Info
                <img
                  src="../assets/images/caret-down.png"
                  width="7px"
                  style="margin-bottom: 2px"
                />
              </a>
              <ul>
                <li>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/profile?no=${RegNo}`"
                  >
                    <span name="profileTitleEn"></span>
                  </a>
                </li>
                <li>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${RegNo}`"
                    >Products</a
                  >
                </li>
                <li v-if="!isOverseas && !Exh_FoodTaichung">
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${RegNo}`"
                    >Booth Events</a
                  >
                </li>
                <li>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${RegNo}`"
                    >Press Release</a
                  >
                </li>
                <li>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${RegNo}`"
                    >Video</a
                  >
                </li>

                <li v-if="isOverseas">
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/certificationApply?no=${RegNo}`"
                    >Certification Apply</a
                  >
                </li>
                <li v-if="isOverseas">
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/Fascia?no=${RegNo}`"
                    >Fascia Entry</a
                  >
                </li>
                <li v-if="isOverseas">
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/Badge?no=${RegNo}`"
                    >Badge Application</a
                  >
                </li>
              </ul>
            </li>

            <li id="event">
              <a
                >Other Events
                <img
                  src="../assets/images/caret-down.png"
                  width="7px"
                  style="margin-bottom: 2px"
                />
              </a>
              <ul></ul>
            </li>

            <li id="upgrade">
              <a
                >Additional Services
                <img
                  src="../assets/images/caret-down.png"
                  width="7px"
                  style="margin-bottom: 2px"
                />
              </a>
              <ul>
                <li>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgrade?no=${RegNo}`"
                    >Additional Services Info.</a
                  >
                </li>
                <li>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/chanchaoApp?no=${RegNo}`"
                    >Chan Chao App</a
                  >
                </li>
                <li>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeEdm?no=${RegNo}`"
                    >Send e-Newsletter</a
                  >
                </li>
              </ul>
            </li>

            <li id="invite">
              <a
                >Invitation
                <img
                  src="../assets/images/caret-down.png"
                  width="7px"
                  style="margin-bottom: 2px"
                />
              </a>
              <ul></ul>
            </li>

            <li id="inquiry">
              <a
                :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${RegNo}`"
                >Inquiries</a
              >
            </li>

            <li id="download">
              <a
                :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/en/download?no=${RegNo}`"
                >Download</a
              >
            </li>
            <!-- for mobile -->

            <div class="bg-list">
              <li class="langTw">
                <a name="toCnVersion" href="">Chinese Version</a>
              </li>
              <li class="indexList">
                <a href="" @click.prevent="toExhList">Exhibition List</a>
              </li>
              <li class="logout">
                <a href="/apiLogin2/Logout"
                  ><span name="Company"></span>Logout</a
                >
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
export default {
  data() {
    return {
      RegNo: "",
      ExhibitionName: "",
      ExhLogo: "",
      isOverseas: false,
      Exh_FoodTaichung: false,
    };
  },

  methods: {
    toExhList() {
      document.location.href =
        "https://www.chanchao.com.tw/ExhibitorServiceTW/en";
    },
  },

  created() {
    //4表單狀態css公式

    const vm = this;

    let nowPage = location.href;
    vm.RegNo = nowPage.split("no=")[1].split("&")[0];

    $(document).ready(function () {
      //1
      $("#menu li").hover(
        function () {
          $(this).addClass("menuHover").children("ul").slideDown(200);
          if ($(this).children("ul").is(":animated")) return;
        },
        function () {
          $(this).removeClass("menuHover").children("ul").stop().slideUp(200);
        },
      );

      //2

      $.each($("#menu li a, #menuContainer h1 a"), function () {
        let CurReg = $(this).attr("href");

        if (CurReg) {
          // 根本解決點：增加判斷，如果網址已經有 no= 就不再重複加
          if (CurReg.indexOf("no=") === -1) {
            let querytype = CurReg.indexOf("?") !== -1 ? "&no=" : "?no=";
            let AddReg = CurReg + querytype + vm.RegNo;
            $(this).attr("href", AddReg);
          }
        }
      });

      //3

      let pathname = location.href.substr(location.href.lastIndexOf("/") + 1);

      if (pathname.match("home")) {
        $("li#home").addClass("selected");
      }
      if (pathname.match("news")) {
        $("li#profile").addClass("selected");
      } //只要檔名包含press就抓出來
      if (pathname.match("profile")) {
        $("li#profile").addClass("selected");
      }
      if (pathname.match("product")) {
        $("li#profile").addClass("selected");
      }
      if (pathname.match("video")) {
        $("li#profile").addClass("selected");
      }
      if (pathname.match("directory")) {
        $("li#directory").addClass("selected");
      }

      if (pathname.match("Boothevent")) {
        $("li#profile").addClass("selected");
      } else if (pathname.match("event")) {
        $("li#event").addClass("selected");
      }

      if (pathname.match("upgrade")) {
        $("li#upgrade").addClass("selected");
      }
      if (pathname.match("invite")) {
        $("li#invite").addClass("selected");
      }
      if (pathname.match("download")) {
        $("li#download").addClass("selected");
      }

      if (pathname.match("inquiry")) {
        $("li#inquiry").addClass("selected");
      }

      //mobile menu open
      if (/android|iPad|iPhone|iPod/i.test(navigator.userAgent)) {
        $("#menu li.selected").children("ul").slideDown(0);
      }

      //4

      window.scrollTo(0, 1);
      let menu = $("h4.openMenu");
      let submenu = $("ul#menu");
      let content = $("footer, header, article");

      menu.bind("click", open);

      function open() {
        submenu.toggle(200);
        content.bind("click", close);
        menu.toggleClass("changColor");
        //win.bind("scroll",close);
      }

      function close() {
        submenu.fadeOut(200);
        content.unbind("click");
        menu.removeClass("changColor");
        //win.unbind("scroll");
      }

      //5

      //mobile pic/table oversize //重要!!!!

      $(".DefaultStyleSheet table, .DefaultStyleSheet img").css({
        "max-width": "100%",
      });
      $(".DefaultStyleSheet img").css({ height: "auto" });

      //6
      //頁面自動高度
      setTimeout(function () {
        let winHeight = $(window).height();
        let footerH = $("footer").outerHeight();
        let menuH = $("#menuWrapper").outerHeight();
        let navH = $("#navWrapper").outerHeight();
        let trackH = $("#track").outerHeight();
        let getHeight = winHeight - (footerH + menuH + navH + trackH);
        if (getHeight > 0) {
          if ($(window).width() > 801) {
            let getHeight = winHeight - (footerH + menuH + navH + trackH);
            $("article").css("min-height", getHeight - 30);
            $(".articleEn").css("min-height", getHeight - 30);
          } else {
            let getHeight = winHeight - (footerH + navH);
            $(".contentBox").css("min-height", getHeight);
          }
        }
      }, 200);

      //7
      //RWD item remove
      setTimeout(function () {
        if ($(window).width() > 801) {
          $(".NoShowInPC").remove();
        } else {
          $(".NoShowInMobile").remove();
        }
      }, 200);
    });

    //2.取得表單名稱

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=en`,
      )
      .then((response) => {
        console.log(response.data.Code == 404);
        if (response.data.Code == 404) {
          document.location.href =
            "https://www.chanchao.com.tw/ExhibitorServiceTW/en";
        } else if (!response.data.Data.exhcode) {
          document.location.href =
            "https://www.chanchao.com.tw/ExhibitorServiceTW/en";
        }

        if (response.data.Data.ExpoLocation == "O") {
          vm.isOverseas = true;
        } else {
          vm.isOverseas = false;
        }

        let ExhCode = response.data.Data.Original_Code;
        if (ExhCode == "TCFB") {
          vm.Exh_FoodTaichung = true;
        } else {
          vm.Exh_FoodTaichung = false;
        }

        vm.ExhibitionName = response.data.Data.Exhibition;
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;

        if (response.data.Data.DirectoryArchived == 0) {
          $(".NavDirectory").addClass("hideDirectory");
        } else {
          $(".NavDirectory").removeClass("hideDirectory");
        }
        if (response.data.Data.DirectoryHardcopy == 1) {
          $('[name="directoryTitle"]').text("會刊登錄");
          $('[name="directoryTitleEn"]').text("Directory Entry");
          $('[name="profileTitleEn"]').text("Basic Information");
          $('[name="homeCompanyInfo"]').text("基本資料");
          $('[name="homeDirectoryTitle"]').text("會刊登錄");
          $('[name="homeDirectoryTitleEn"]').text("Directory Entry");
          $(".HasDirectory").addClass("show");
          $(".NoDirectory").addClass("hide");
        } else {
          $('[name="directoryTitle"]').text("廠商介紹");
          $('[name="directoryTitleEn"]').text("Exhibitor Profile");
          $('[name="profileTitleEn"]').text("Basic Information");
          $('[name="homeCompanyInfo"]').text("基本資料");
          $('[name="homeDirectoryTitle"]').text("廠商介紹");
          $('[name="homeDirectoryTitleEn"]').text("Exhibitor Profile");
          $(".HasDirectory").addClass("hide");
          $(".NoDirectory").addClass("show");
        }

        let nowPage = location.href;

        // console.log(nowPage)

        let lang = "en";

        if (lang == "tw") {
          let getUrl = nowPage.split("ExhibitorServiceTW")[1];

          // console.log(getUrl)

          $("[name=toEnVersion]").attr(
            "href",
            "https://www.chanchao.com.tw/ExhibitorServiceTW/en" + getUrl,
          );
        } else {
          let getenUrl = nowPage.split("/en")[1];
          $("[name=toCnVersion]").attr(
            "href",
            "https://www.chanchao.com.tw/ExhibitorServiceTW" + getenUrl,
          );
        }
      });

    //5.選單上的邀請判斷是哪一種類型(民生 工業)
    //get invitation menu

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=en`,
      )
      .then((response) => {
        // console.log(response.data.Code)

        if (response.data.Code == 200) {
          $("#menu li#invite").show();
          let html = "";
          for (var i = 0; i < response.data.Data.length; i++) {
            if (
              response.data.Data[i].Url == "inviteReg" ||
              response.data.Data[i].Url == "invite"
            ) {
              // let GetUrl = response.data.Data[i].Url
              // let UrlDelHtml = GetUrl.split('.')[0]
              html += `<li><a href="${response.data.Data[i].Url}?no=${vm.RegNo}">${response.data.Data[i].MenuName}</a></li>`;
              $("a.getInvUrl").attr(
                "href",
                response.data.Data[i].Url + "?no=" + vm.RegNo,
              );
            } else {
              // let GetUrl2 = response.data.Data[i].Url
              // let UrlDelHtml2 = GetUrl2.split('.')[0]
              html += `<li><a href="${response.data.Data[i].Url}?no=${vm.RegNo}" >${response.data.Data[i].MenuName}</a></li>`;
            }
          }
          $("#menu li#invite ul").append(html);
        } else {
          $("#menu li#invite").remove();
        }
      });

    //5.判定權限及載入大會活動

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/RegNoCheck/${vm.RegNo}?lang=en`,
      )
      .then((response) => {
        if (!response.data.Data.RegNoCheck) {
          window.location.href =
            "https://www.chanchao.com.tw/ExhibitorServiceTW/";
        }

        $("body").addClass("opacity");

        if (response.data.Data.Exhibition.length > 47) {
          $(".HideTitle1").addClass("displayNone");
          $('[name="Exhibition"]').text(response.data.Data.Exhibition);

          // $('[name=logo]').attr('src', `//www.ccie.com.tw/exhibition/images/exlogo/${vm.ExhLogo}`)
        } else {
          $(".HideTitle").addClass("displayNone");

          $('[name="Exhibition"]').text(response.data.Data.Exhibition);
          // $('[name=logo]').attr('src', `//www.ccie.com.tw/exhibition/images/exlogo/${vm.ExhLogo}`)
        }

        //RegNo Success then get data
        $('[name="Exhibitionindex"]').text(
          `：${response.data.Data.Exhibition}`,
        );

        //get other menu 大會活動

        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/MenuOthers/${vm.RegNo}?lang=en`,
          )
          .then((response) => {
            if (response.data.Data.length) {
              $("#menu li#event").show();
              let html = "";
              for (let i = 0; i < response.data.Data.length; i++) {
                if (response.data.Data[i].Url.indexOf("?") >= 0) {
                  html += `<li><a href="${response.data.Data[i].Url}&no=${vm.RegNo}">${response.data.Data[i].MenuName}</a></li>`;
                } else {
                  html += `<li><a href="${response.data.Data[i].Url}?no=${vm.RegNo}">${response.data.Data[i].MenuName}</a></li>`;
                }
              }
              $("#menu li#event ul").append(html);
            }
          });
      });
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 800px) {
  h4.openMenu {
    display: block;
    position: fixed;
    width: 50px;
    height: 50px;
    top: 0;
    right: 0;
    background-image: url(../assets/images/bars.svg);
    background-size: auto 60%;
    background-repeat: no-repeat;
    background-position: center center;
    text-indent: -9999px;
    z-index: 200;
    transition: all 0.3s ease-out;
  }
  h4.changColor {
    background-color: #eee;
    background-image: url(../assets/images/close.svg);
    transition: all 0.3s ease-out;
  }

  #menu li.lang,
  #menu li.langTw,
  #menu li.indexList,
  #menu li.logout {
    display: block;
    background-image: url(../assets/images/langBlack.svg);
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: center left 20px;
    padding-left: 25px;
  }

  #menu li.indexList {
    background-image: url(../assets/images/indexListBlack.svg);
  }
  #menu li.logout {
    background-image: url(../assets/images/logoutBlack.svg);
  }
  #menu li.langTw {
    background-image: url(../assets/images/langTWBlack.svg);
  }

  ul#quickLink li.lang a {
    background-image: url(../assets/images/lang.svg);
  }
  ul#quickLink li.member a {
    background-image: url(../assets/images/member.svg);
  }

  ul#quickLink li.logout a {
    background-image: url(../assets/images/logout.svg);
  }

  ul#quickLink li.langTw a {
    background-image: url(../assets/images/langTW.svg);
  }
  ul#quickLink li.indexList a {
    background-image: url(../assets/images/indexList.svg);
  }

  .homeLeft {
    margin-bottom: 0px;
    margin-top: 0px;
  }
}

.hideDirectory {
  display: none;
}
</style>
